import { render, staticRenderFns } from "./StaffLocactionVerification.vue?vue&type=template&id=1461f8cd&scoped=true"
import script from "./StaffLocactionVerification.vue?vue&type=script&lang=js"
export * from "./StaffLocactionVerification.vue?vue&type=script&lang=js"
import style0 from "./StaffLocactionVerification.vue?vue&type=style&index=0&id=1461f8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461f8cd",
  null
  
)

export default component.exports